import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

// Import your translation resources
import enTranslation from './locales/en.json';

// Define the translation resources
const resources = {
  en: {
    translation: enTranslation,
  },
};

// Initialize i18next
i18n
  .use(initReactI18next) // Connects i18next with React
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if key is not found in current language
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    // Other i18next options
    react: {
      useSuspense: false, // Set to false to avoid suspense if not using React.lazy
    },
    returnObjects: true,
  });

export default i18n;
